import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [RouterLink],
  template: `
    <main class="max-w-7xl mx-auto px-8 py-32">

      <!-- Hero -->
      <header class="mb-20 text-center max-w-3xl mx-auto">
        <span class="font-sans font-bold text-sm text-gold-accent mb-4 block tracking-widest uppercase">Our Story</span>
        <h1 class="font-serif text-5xl text-on-surface mb-8">About Regency House Cleaning</h1>
        <div class="w-24 h-1 bg-gold-accent mx-auto"></div>
      </header>

      <!-- Mission Statement -->
      <section class="mb-24 grid md:grid-cols-2 gap-16 items-center">
        <div class="space-y-8">
          <p class="font-sans text-xl text-on-surface-variant leading-relaxed">
            Founded and operating exclusively in New York City across Manhattan, Brooklyn, and Queens, Regency House Cleaning delivers exceptional residential stewardship with meticulous attention to detail, quiet discretion, and white-glove care.
          </p>
          <p class="font-sans text-xl text-on-surface-variant leading-relaxed">
            Every visit is tailored to your home's unique needs, ensuring immaculate results and a
            consistently elevated experience. Our mission is to help you enjoy a beautifully maintained
            home while providing the dependable, personalized service you deserve.
          </p>
          <div class="pt-4">
            <button
              class="bg-gold-accent text-black font-bold h-14 px-12 rounded-lg shadow-lg hover:brightness-105 active:scale-95 transition-all"
              routerLink="/book">
              Book a Cleaning
            </button>
          </div>
        </div>

        <!-- Values Grid -->
        <div class="grid grid-cols-2 gap-6">
          <div class="bg-stone-50 p-8 rounded-xl border border-stone-200 flex flex-col gap-4">
            <span class="material-symbols-outlined text-3xl text-gold-accent" style="font-variation-settings: 'FILL' 1;">verified</span>
            <h3 class="font-serif text-xl text-on-surface">Meticulous Detail</h3>
            <p class="font-sans text-sm text-on-surface-variant leading-relaxed">Every corner, surface, and space receives our full attention.</p>
          </div>
          <div class="bg-stone-50 p-8 rounded-xl border border-stone-200 flex flex-col gap-4">
            <span class="material-symbols-outlined text-3xl text-gold-accent" style="font-variation-settings: 'FILL' 1;">handshake</span>
            <h3 class="font-serif text-xl text-on-surface">Professionalism</h3>
            <p class="font-sans text-sm text-on-surface-variant leading-relaxed">Certified specialists trained in luxury home care etiquette.</p>
          </div>
          <div class="bg-stone-50 p-8 rounded-xl border border-stone-200 flex flex-col gap-4">
            <span class="material-symbols-outlined text-3xl text-gold-accent" style="font-variation-settings: 'FILL' 1;">favorite</span>
            <h3 class="font-serif text-xl text-on-surface">Care & Trust</h3>
            <p class="font-sans text-sm text-on-surface-variant leading-relaxed">Fully vetted professionals who treat your home as their own.</p>
          </div>
          <div class="bg-stone-50 p-8 rounded-xl border border-stone-200 flex flex-col gap-4">
            <span class="material-symbols-outlined text-3xl text-gold-accent" style="font-variation-settings: 'FILL' 1;">star</span>
            <h3 class="font-serif text-xl text-on-surface">Elevated Experience</h3>
            <p class="font-sans text-sm text-on-surface-variant leading-relaxed">Consistently exceptional results, every single visit.</p>
          </div>
        </div>
      </section>

      <!-- Divider -->
      <div class="w-full h-px bg-stone-200 mb-24"></div>

      <!-- CTA Banner -->
      <section class="bg-stone-50 border border-stone-200 rounded-2xl p-16 text-center">
        <h2 class="font-serif text-4xl text-on-surface mb-6">Ready to experience the Regency difference?</h2>
        <p class="font-sans text-lg text-on-surface-variant max-w-xl mx-auto mb-10">
          Schedule your first cleaning and discover what a truly personalized home care service feels like.
        </p>
        <div class="flex flex-col sm:flex-row gap-6 justify-center">
          <button
            class="bg-gold-accent text-black font-bold h-14 px-12 rounded-lg shadow-lg hover:brightness-105 active:scale-95 transition-all"
            routerLink="/book">
            Book Now
          </button>
          <button
            class="border-2 border-on-surface text-on-surface font-bold h-14 px-12 rounded-lg hover:bg-stone-100 transition-all"
            routerLink="/services">
            View Services
          </button>
        </div>
      </section>

    </main>
  `,
})
export class AboutComponent {}
